<template>
	<div class="c-footer">
		<div class="c-footer__inner">
			<div class="c-footer__item">A</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.c-footer {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: var(--margin-lg);
	overflow: hidden;

	&__inner {
		display: flex;
		padding: var(--margin-lg);
		background-color: var(--g3);
		border-radius: var(--border-radius);
		box-shadow: 0 1.9px 3.4px rgba(0, 0, 0, 0.121),
			0 6.5px 11.4px rgba(0, 0, 0, 0.179), 0 29px 51px rgba(0, 0, 0, 0.3);
		transform: translateY(150%);
		transition: transform 200ms cubic-bezier(0.175, 0.47, 0.38, 1.01);
	}

	&:hover {
		.c-footer__inner {
			transform: translateY(0);
		}
	}

	&__item {
		background-color: var(--g2);
		padding: var(--margin-lg);
	}
}
</style>